import React from 'react'
import { Accordion, Card } from 'react-bootstrap';

const data=[
    {
        question: 'q1',
        answer:'a1',
    },
    {
        question: 'q2',
        answer:'a2'
    }

]

export default class faq extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setActiveId:null,
            activeId: 0,
            arrow: '▼',
            isActive: false,
            activateTab: 0
          }
          this.activateTab = this.activateTab.bind(this);
         
    }
    activateTab(index) {
		this.setState(prev => ({
			activeTab: prev.activeTab === index ? -1 : index
		}));
	}
     toggleActive(key) {
         /* if(this.activeId == key){
            this.setState({setActiveId : null});
         } else{
            this.setState({setActiveId:key});
         } */
        /*  if(this.activeId==key){
            this.setState({isActive:true});
         }
         if(this.activeId==true){

         } */
         
        
      }
    render() {
        const {arrow, activeId, setActiveId}= this.state;
        const { activeTab } = this.state;


        return (
           
            <div className="container-fluid rtl">
                <div className="row">
                    <div className="container pb-5">
                    <h1 className="block-title text-center title mb-5 mt-5">
                    الأسئلة الشائعة </h1>
                    <div className="col-12 col-md-8 mx-auto">
                    <Accordion defaultActiveKey={activeTab} >
                         <Card className="accordion-card">
                            <Accordion.Toggle as={Card.Header} eventKey="0" className="accordion-card-toggle-closed" onClick={() => this.toggleActive('0')} >
                            ما هو الفرق بين المؤسسة والشركة؟
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                            <Card.Body>تقتصر ملكية المؤسسة على شخص واحد فقط، أما الشركة تسمح بدخول عدة شركاء في منشأة واحدة، وُتعد الملكية إحدى أهم الفوارق بينهما.
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className="accordion-card">
                            <Accordion.Toggle as={Card.Header} eventKey="1" className="accordion-card-toggle-closed">
                            ما هو برنامج حماية الأجور؟
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="1">
                            <Card.Body>لضمان حق الموظف السعودي والوافد، أطلقت وزارة الموارد البشرية برنامج حماية الأجور لرصد عمليات صرف الأجور لكافة العاملين والعاملات بالقطاع الخاص، وقياس مدى التزام المنشآت بدفع الأجور بالوقت المحدد وبالقيمة المتفق عليها بين المتعاقدين.
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className="accordion-card">
                            <Accordion.Toggle as={Card.Header} eventKey="2" className="accordion-card-toggle-closed">
                            ماهي خطوات فتح ملف مكتب العمل عند استخراج السجل التجاري؟
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="2">
                            <Card.Body>عبر موقع مكتب العمل الإلكتروني، يتم فتح ملف منشأة جديدة، وتفعيل الملف عبر تقديم خطاب تفعيل مدير حساب وتعهد بالتزام العمالة.

                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className="accordion-card">
                            <Accordion.Toggle as={Card.Header} eventKey="3" className="accordion-card-toggle-closed">
                            تسجيل العنوان الوطني هل يكون باسم المستأجر أو المؤجر؟
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="3">
                            <Card.Body>يسجل
                                العنوان الوطني باسم المؤجر وصاحب المنشأة ولا يسجل باسم المستأجر.
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className="accordion-card">
                            <Accordion.Toggle as={Card.Header} eventKey="4" className="accordion-card-toggle-closed">
                             هل يمكن تعديل بيانات السجل التجاري؟
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="4">
                            <Card.Body>نعم يمكن تعديل بيانات السجل التجاري عن طريق موقع وزارة التجارة الالكتروني برسوم رمزية.

                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className="accordion-card">
                            <Accordion.Toggle as={Card.Header} eventKey="5" className="accordion-card-toggle-closed">
                            كم عدد العمالة التي ينطبق عليها مبادرة المقابل المالي؟
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="5">
                            <Card.Body>يختلف العدد بمقاييس النشاط ونسبة التوطين.

                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className="accordion-card">
                            <Accordion.Toggle as={Card.Header} eventKey="6" className="accordion-card-toggle-closed">
                            ماهي نسبة التوطين؟
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="6">
                            <Card.Body>نسبة التوطين هي عدد العمالة المواطنين (السعوديين) لدى المنشأة، وتقاس نسبة التوطين حسب مقاييس ومعايير وزارة الموارد البشرية والتنمية الاجتماعية.
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        </Accordion>
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}
